import React from 'react';
import { Button, Checkbox } from 'antd';
import { CloseOutlined } from '@ant-design/icons';

const BinnedDateFilterComponent = ({ attributeFilters, setAttributeFilters, currentFilter }) => {
  const handleClearFilters = () => {
    setAttributeFilters({});
  };

  const clearButton = Object.keys(attributeFilters).length > 0 && (
    <Button
      icon={<CloseOutlined />}
      onClick={handleClearFilters}
      style={{ marginBottom: '10px', color: 'blue' }}
    >
      Clear Filters
    </Button>
  );

  const bins = [
    'Not Planned', // Added
    'New',
    'On Plan',     // Added
    'Unchanged',
    'Accelerated',
    'Delayed (1 to 7 days)',
    'Delayed (8 to 14 days)',
    'Delayed (15 to 30 days)',
    'Delayed (1 to 3 months)', // Added
    'Delayed (more than 3 months)', // Added
];
  const updateAttributeFilters = (newValue) => {
    setAttributeFilters({
      ...attributeFilters,
      [currentFilter]: newValue,
    });
  };

  const allSelected =
    attributeFilters[currentFilter] === undefined ||
    attributeFilters[currentFilter]?.length === bins.length;

  return (
    <div style={{ marginTop: '10px' }}>
      {clearButton}
      <Checkbox
        indeterminate={
          attributeFilters[currentFilter]?.length > 0 &&
          attributeFilters[currentFilter]?.length < bins.length
        }
        checked={allSelected}
        onChange={(e) => {
          updateAttributeFilters(e.target.checked ? bins : []);
        }}
      >
        (Select all)
      </Checkbox>
      {bins.map((bin) => (
        <div key={bin}>
          <Checkbox
            checked={
              attributeFilters[currentFilter] === undefined ||
              attributeFilters[currentFilter]?.includes(bin)
            }
            onChange={(e) => {
              const currentFilters = attributeFilters[currentFilter] || [];
              updateAttributeFilters(
                e.target.checked
                  ? [...currentFilters, bin]
                  : currentFilters.filter((val) => val !== bin)
              );
            }}
          >
            {bin}
          </Checkbox>
        </div>
      ))}
    </div>
  );
};
export default BinnedDateFilterComponent;
